import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const lang =
(typeof window !== "undefined" &&
        window.searchAppConfig &&
        window.searchAppConfig.engineName && window.searchAppConfig.lang ) ? window.searchAppConfig.lang
    :
    (process.env.REACT_APP_LANG??'en')



i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: lang,
    resources: {
        en: {
            translations: require('./locales/en/translations.json')
        },
        it: {
            translations: require('./locales/it/translations.json')
        },
        es: {
            translations: require('./locales/es/translations.json')
        },
        fr: {
            translations: require('./locales/fr/translations.json')
        },
        de: {
            translations: require('./locales/de/translations.json')
        },
        nl: {
            translations: require('./locales/nl/translations.json')
        },
        zhCn: {
            translations: require('./locales/zh-cn/translations.json')
        },
        zhHk: {
            translations: require('./locales/zh-hk/translations.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = ['en', 'it', 'es', 'fr'];

export default i18n;